module.exports = __webpack_public_path__ + "assets/img/f324a3c8f0efd3fbb53c5df0a9c09a22.svg";